/**
 * TODO: Update this component to use your client-side framework's link
 * component. We've provided examples of how to do this for Next.js, Remix, and
 * Inertia.js in the Catalyst documentation:
 *
 * https://catalyst.tailwindui.com/docs#client-side-router-integration
 */

import * as Headless from '@headlessui/react';
import React, { forwardRef } from 'react';

export const Link = forwardRef(function Link(
  {
    children,
    ...props
  }: {
    href: string;
    'aria-label'?: string;
    children: React.ReactNode;
  } & React.ComponentPropsWithoutRef<'a'>,
  ref: React.ForwardedRef<HTMLAnchorElement>
) {
  return (
    <Headless.DataInteractive>
      <a {...props} ref={ref} aria-label={props['aria-label'] || 'Link'}>
        {children}
      </a>
    </Headless.DataInteractive>
  );
});
